export enum ShareReportDialogActions {
    SHARE = 'share',
    CANCEL = 'cancel',
}
